<template>
  <search-form-choice-list
    :label="label"
    :name="name"
    :option-groups="optionGroups"
    :value="choiceListValue"
    @input="handleInput"
  />
</template>

<script>
import SearchFormChoiceList from './choice-list.vue'

const formatPrice = (number) =>
  `${Intl.NumberFormat('en-US').format(number).replaceAll(',', "'")}.-`

const formatBudgetOptions = (numbers) => {
  const options = numbers.map((number) => ({
    label: formatPrice(number),
    value: number,
  }))
  return [{ id: '1', options }]
}

export default {
  name: 'SearchFormBudgetSelect',
  components: { SearchFormChoiceList },
  props: {
    label: String,
    name: String,
    options: Array,
    value: Number,
  },
  computed: {
    optionGroups() {
      return formatBudgetOptions(this.options)
    },
    choiceListValue() {
      if (this.value) {
        return [this.value]
      }
      return []
    },
  },
  methods: {
    handleInput(selection) {
      this.$emit(
        'input',
        selection[0] === undefined ? undefined : Number(selection[0])
      )
    },
  },
}
</script>
